import { IntegrationIconProps } from './types';

const ProductHunt = ({ dimension }: IntegrationIconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="14" fill="#D85637" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 9H18C20.7614 9 23 11.2386 23 14C23 16.7614 20.7614 19 18 19H14V23H11V9ZM14 16V12H18C19.1046 12 20 12.8954 20 14C20 15.1046 19.1046 16 18 16H14Z"
      fill="white"
    />
  </svg>
);
export default ProductHunt;
